import React, { useEffect } from 'react';
import { RecaptchaV2 } from './RecaptchaV2';
import { RecaptchaV3 } from './RecaptchaV3';
import { RecaptchaProps } from './types/recatptcha-props';
import { RecaptchaVersion } from './types/recatptcha-version';

type Props = RecaptchaProps & { version: RecaptchaVersion };

const Recaptcha: React.FC<Props> = ({ version, ...props }) => {
  useEffect(() => {
    if (!version) {
      return;
    }
    console.log(`[Recaptcha] recieved ${version} key`);
  }, [version]);

  if (!props.captchaKey) {
    return null;
  }

  if (version === RecaptchaVersion.V3) {
    return <RecaptchaV3 {...props} />;
  }

  return <RecaptchaV2 {...props} />;
};

export default React.memo(Recaptcha);
